// @core/api/endpoints/webhook/delete_endpoint.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/webhook';

/**
 * Delete webhook endpoint
 * Permanently removes a webhook endpoint. The endpoint will stop receiving events immediately and delivery history will be archived.
 */
export async function DeleteEndpoint(
  endpoint_id: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/endpoints/:endpoint_id`;
  requestPath = requestPath.replace(':endpoint_id', encodeURIComponent(endpoint_id));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
